<template>
  <component :is="componentTag"
             round
             v-bind="$attrs"
             color="primary"
             text-color="white"
             :class="{'btn btn__common btn__common--primary' : clickable}"
             clickable
  >
    <template v-if="user">
      {{ $userInitials(user) }}
    </template>
    <q-icon
        v-else
        name="account_circle"
        aria-label="profiel icoon"
    />
    <slot />
  </component>
</template>

<script>

export default {
  props: {
    user: {
      type: Object,
      required: false,
    },
    clickable: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    componentTag () {
      if (this.clickable) return 'q-btn'
      return 'q-avatar'
    },
  },
}


</script>
